<template>
    <section class="search">
        <h1>Escolha a Plataforma</h1>
        <form v-on:submit.prevent="onSubmit">
            <div class="form-group">
                <label for="platform"></label>
                <select name="platform" id="platform" v-model="platform">
                    <option value="psn">Playstation</option>
                    <option value="xbl">Xbox</option>
                    <option value="Origin">Origin</option>
                </select>
            </div>
            <div class="form-group">
                <label for="gamertag">Gamertag</label>
                <input
                    type="text" 
                    name="text" 
                    v-model="gamertag" 
                    id="gamertag"
                    placeholder="Origin ID, Xbox Live gamertag, PSN ID, etc"
                />
            </div>
            <div class="form-group">
                <input type="submit" value="Consultar" class="btn" />
            </div>
        </form>
    </section> 
</template>

<script>
export default {
    name: 'Serach',
    data() {
        return {
            platform: "psn",
            gamertag: ""
        };
    },
    beforeCreate() {
        document.body.className = "body-bg-image";
    },
    methods: {
        onSubmit() {
            if(!this.gamertag) {
                this.$toasted.show("Por favor digite o gamertag", {
                    duration: 3000,
                    icon: "exclamation-circle"
                });
            }
            else{
                this.$router.push(`/profile/${this.platform}/${this.gamertag}`);
            }
        }
    }
};
</script>

<style>

</style>
